module.exports = __webpack_public_path__ + "img/waiting2.fae1a9cf.svg";